export const CHARGE_TYPE_LABEL = {
  professional: 'PRO',
  technical: 'TECH',
  'pro-tech': 'PRO/TECH',
  SHARED_CODES: 'SHARED'
};
